import React from 'react';

import InstrumentResolution from '../elements/InstrumentResolution';

class SettingsTab extends React.Component {
  constructor(props){
    super(props);
    this.state={
      resolutionValue: props.parameters.resolutionDefault
    }
  }

  onResolutionChange = (e) => {
    // console.log(e);
    this.setState({resolutionValue: e.target.value});
    this.props.updateParameters({resolutionDefault: e.target.value});
  }

  render(){
    // console.log(this.props);
    return(
      <div>
        <div className="parameters-subcategory-title-wrapper">Settings</div>
        <InstrumentResolution 
          title="Instrument Resolution"
          onResolutionChange={this.onResolutionChange}
          options={this.props.instrumentResolutionOptions}
          resolutionDefault={this.props.parameters.resolutionDefault}
          resolutionValue={this.state.resolutionValue}
          disabled={false}
        />
      </div>
    )
  }
}

export default SettingsTab;